import Buttons from '@admin/components/buttons'
import Button from '@admin/components/button'
import Img from '@admin/components/html/img'
import Icon from '@admin/components/icon'
import T from '@admin/components/t'
import PropTypes from 'prop-types'
import React from 'react'

class Message extends React.Component {

  static contextTypes = {
    modal: PropTypes.object
  }

  static propTypes = {
    animation: PropTypes.string,
    backgroundColor: PropTypes.string,
    buttons: PropTypes.array,
    button: PropTypes.object,
    link: PropTypes.object,
    component: PropTypes.any,
    color: PropTypes.string,
    icon: PropTypes.string,
    image: PropTypes.string,
    poster: PropTypes.string,
    preview: PropTypes.string,
    spinning: PropTypes.bool,
    svg: PropTypes.string,
    text: PropTypes.string,
    title: PropTypes.string
  }

  static defaultProps = {
    backgroundColor: null,
    animation: null,
    color: null
  }

  state = {
    animate: false
  }

  render() {
    const { component, icon, image, link, poster, preview, svg, text, title } = this.props
    const { buttons } = this._getButtons()
    return (
      <div className={ this._getClass() }>
        <div className="maha-message-panel">
          { (icon || svg) &&
            <div className="maha-message-panel-icon">
              <Icon icon={ icon } svg={ svg } className={ this._getIconClass() } />
            </div>
          }
          { image &&
            <div className="maha-message-panel-icon">
              <Img src={ image } />
            </div>
          }
          { preview &&
            <div className="maha-message-panel-preview">
              <Img src={ preview } />
            </div>          
          }
          { poster &&
            <div className="maha-message-panel-poster">
              <Img src={ poster } />
            </div>
          }
          { title && <h3><T text={ title } /></h3> }
          { text && <p><T text={ text } /></p> }
          { component }
          { buttons.length > 0 && <Buttons { ...this._getButtons() } /> }
          { link && <Button { ...this._getLink() } />}
        </div>
      </div>
    )
  }

  _getLink() {
    const { link } = this.props
    return {
      ...link,
      className: 'link'
    }
  }

  componentDidMount() {
    if(!this.props.animation) return
    setTimeout(() => {
      this.setState({ animate: true })
      setTimeout(() => {
        this.setState({ animate: false })
      }, 500)
    }, 500)
  }

  _getButtons() {
    const { buttons, button } = this.props
    return {
      buttons: [
        ...button ? _.castArray(button) : [],
        ...buttons || []
      ].map(button => ({
        basic: true,
        color: 'blue',
        ...button,
        fluid: false
      }))
    }
  }

  _getClass() {
    const { backgroundColor } = this.props
    const classes = ['maha-message']
    if(backgroundColor) classes.push(backgroundColor)
    return classes.join(' ')
  }

  _getIconClass() {
    const { animate } = this.state
    const { animation, color, spinning } = this.props
    const classes = []
    if(animate && animation) classes.push(`animating transition ${animation}`)
    if(color) classes.push(color)
    if(spinning) classes.push('spinning')
    return classes.join(' ')
  }

}

export default Message
